import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import ListSubheader from '@mui/material/ListSubheader'
import Typography from '@mui/material/Typography'
import { FormattedMessage } from 'react-intl'
import { isEmpty, filter, groupBy, map, get } from 'lodash'

const NetworkSelectDialog = ({
  open,
  onClose,
  onSelect,
  networks,
  projectsById,
  currentProjectId,
  titleId,
  emptyId,
}) => {
  const handleSelect = (network) => {
    onSelect(network)
    onClose()
  }

  // Group networks: current project first, then by project for external
  const currentProjectNetworks = filter(networks, (n) => get(n, 'projectId') === currentProjectId)
  const externalNetworks = filter(networks, (n) => get(n, 'projectId') !== currentProjectId)
  const externalByProject = groupBy(externalNetworks, 'projectId')

  const hasNetworks = !isEmpty(networks)

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <FormattedMessage id={titleId} />
      </DialogTitle>
      <DialogContent>
        {!hasNetworks ? (
          <Typography variant="body2" color="text.secondary">
            <FormattedMessage id={emptyId} />
          </Typography>
        ) : (
          <List>
            {!isEmpty(currentProjectNetworks) && (
              <>
                <ListSubheader>
                  <FormattedMessage id="serviceNetworks.dialog.currentProject" />
                </ListSubheader>
                {currentProjectNetworks.map((network) => (
                  <ListItemButton key={network.id} onClick={() => handleSelect(network)}>
                    <ListItemText primary={network.name} />
                  </ListItemButton>
                ))}
              </>
            )}
            {map(externalByProject, (projectNetworks, projectId) => {
              const project = get(projectsById, projectId)
              return (
                <div key={projectId}>
                  <ListSubheader>
                    {get(project, 'name', projectId)}
                  </ListSubheader>
                  {projectNetworks.map((network) => (
                    <ListItemButton key={network.id} onClick={() => handleSelect(network)}>
                      <ListItemText primary={network.name} />
                    </ListItemButton>
                  ))}
                </div>
              )
            })}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose}>
          <FormattedMessage id="app.actions.cancel.label" />
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default NetworkSelectDialog
